import React from 'react';

// Components

import BlockWrapper from './BlockWrapper';

// Configs
import { configs } from '@constants/configs/configs';

// Utils

import { processJsonTools } from '@utils/tools/processJsonTools';

const NewJsonSetter = props => {

    const {
        id,
        name,
        btnText,
        appType,
        json,
        changeJson,
        isApplyJsonButtonDisabled,
        toggleApplyJsonButtonDisability,
        handleToggle,
        changeData
    } = props;

    const handleJsonInsertion = e => {

        const {
            value
        } = e.target;

        const hasJsonStructure = str => {
            if (typeof str !== 'string') return false;
            try {
                const result = JSON.parse(str,undefined, 4);
                const type = Object.prototype.toString.call(result);
                return type === '[object Object]'
                    || type === '[object Array]';
            } catch (err) {
                return false;
            }
        };

        try {
            if(!hasJsonStructure(value)) {
                throw new Error('Invalid JSON has been provided');

            } else {
                const newJson = JSON.parse(value);

                if(appType === configs.routes.SSAP && !processJsonTools.convertTaxHousehold(newJson).taxHousehold ) {
                    throw new Error('"taxHousehold" property is absent in JSON!');
                } else {
                    changeJson(value);
                    toggleApplyJsonButtonDisability(!isApplyJsonButtonDisabled);
                }
            }
        } catch(e) {
            alert(e);
        }
    };

    const handleJsonApplying = () => {
        changeData(processJsonTools.convertBloodRelationships(processJsonTools.convertTaxHousehold(JSON.parse(json), 'object'), 'household'));
        toggleApplyJsonButtonDisability(true);
        handleToggle({ target: { name } });
        changeJson('');
    };

    return (
        <BlockWrapper id={id}>
            <textarea
                style={{ width: '450px', borderRadius: '5px' }}
                value={json}
                onChange={handleJsonInsertion}
                rows = "25"
                name = "json"
            />
            <button
                disabled={isApplyJsonButtonDisabled}
                onClick={handleJsonApplying}
            >
                { btnText }
            </button>
        </BlockWrapper>
    );
};

export default NewJsonSetter;